import PropTypes from 'prop-types';
import React from 'react';
import { cymbioColors } from '../../../utils/colors';

const strokeColor = cymbioColors.analytics.darkGray;

export function DashboardSalesIcon({ color = strokeColor }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1_2971)">
        <path
          d="M7.49935 4.16669H5.83268C5.39065 4.16669 4.96673 4.34228 4.65417 4.65484C4.34161 4.9674 4.16602 5.39133 4.16602 5.83335V15.8334C4.16602 16.2754 4.34161 16.6993 4.65417 17.0119C4.96673 17.3244 5.39065 17.5 5.83268 17.5H14.166C14.608 17.5 15.032 17.3244 15.3445 17.0119C15.6571 16.6993 15.8327 16.2754 15.8327 15.8334V5.83335C15.8327 5.39133 15.6571 4.9674 15.3445 4.65484C15.032 4.34228 14.608 4.16669 14.166 4.16669H12.4993"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 4.16667C7.5 3.72464 7.6756 3.30072 7.98816 2.98816C8.30072 2.67559 8.72464 2.5 9.16667 2.5H10.8333C11.2754 2.5 11.6993 2.67559 12.0118 2.98816C12.3244 3.30072 12.5 3.72464 12.5 4.16667C12.5 4.60869 12.3244 5.03262 12.0118 5.34518C11.6993 5.65774 11.2754 5.83333 10.8333 5.83333H9.16667C8.72464 5.83333 8.30072 5.65774 7.98816 5.34518C7.6756 5.03262 7.5 4.60869 7.5 4.16667Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.6673 9.16669H9.58398C9.25246 9.16669 8.93452 9.29838 8.7001 9.5328C8.46568 9.76722 8.33398 10.0852 8.33398 10.4167C8.33398 10.7482 8.46568 11.0662 8.7001 11.3006C8.93452 11.535 9.25246 11.6667 9.58398 11.6667H10.4173C10.7488 11.6667 11.0668 11.7984 11.3012 12.0328C11.5356 12.2672 11.6673 12.5852 11.6673 12.9167C11.6673 13.2482 11.5356 13.5661 11.3012 13.8006C11.0668 14.035 10.7488 14.1667 10.4173 14.1667H8.33398"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 14.1666V15M10 8.33331V9.16665"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_2971">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

DashboardSalesIcon.propTypes = {
  color: PropTypes.string,
};
